import React, {PropTypes,Component} from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { I18nextProvider } from 'react-i18next';

import index from './reducers';
import Welcome from './containers/welcome';
import i18nInstance from '../../localization';

let createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
let store = createStoreWithMiddleware(index);

export default class Index extends Component {
  static propsTypes = {
    showOnboarding: PropTypes.bool.isRequired,
    firstTime: PropTypes.bool.isRequired,
    onBoarding: PropTypes.func.isRequired,
    contact: PropTypes.object.isRequired,
    csrfToken: PropTypes.string.isRequired,
    analytics: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    supportedLanguages: PropTypes.array
  }

  render() {
    return(
      <Provider store={store}>
        <I18nextProvider i18n={i18nInstance} >
          <Welcome {...this.props} />
        </I18nextProvider>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/index.jsx